<template>
  <div class="map-container">
    <canvas id="map-canvas" ref="map-canvas" width="1200" height="700"></canvas>
  </div>
</template>

<script>
import {Deck} from '@deck.gl/core';
import {GeoJsonLayer, ArcLayer} from '@deck.gl/layers';

const TARGET_COORDS = [2.1311539, 41.4503539]
const redColor = [255,0,0, 100]
const greenColor = [0,255,0, 100]
const redColorHover = [255,0,0]
const greenColorHover = [0,255,0]

export default {
  name: "MapChart",
  mounted () {
    this.drawMap()
  },
  props: ['chartData'],
  computed: {
    arcs () {
      let arcs = []
      this.chartData.forEach(item => {
        let elIndex = arcs.findIndex(el => el.products == item['Products'] && el.origin == item['Origin'])
        if(elIndex >= 0) {
          arcs[elIndex].sourceEmission += item['Sourcing']
          arcs[elIndex].destinationEmission += item['Average Embodied Carbon (kg CO2e)']
        } else {
          if (item['Origin_coords']) {
            arcs.push({
              products: item['Products'],
              origin: item['Origin'],
              coords: item['Origin_coords'].split(',').reverse().map(e => +e),
              sourceEmission: +item['Sourcing'],
              destinationEmission: +item['Average Embodied Carbon (kg CO2e)'],
            })
          }
        }
      })
      return arcs
    }
  },
  methods: {
    drawMap () {

      // source: Natural Earth http://www.naturalearthdata.com/ via geojson.xyz
      const COUNTRIES =
        'https://d2ad6b4ur7yvpq.cloudfront.net/naturalearth-3.3.0/ne_50m_admin_0_scale_rank.geojson'; //eslint-disable-line
      const AIR_PORTS =
        'https://d2ad6b4ur7yvpq.cloudfront.net/naturalearth-3.3.0/ne_10m_airports.geojson';

      const INITIAL_VIEW_STATE = {
        latitude: TARGET_COORDS[1],
        longitude: TARGET_COORDS[0],
        zoom: 2,
        bearing: 0,
        pitch: 30
      };

      if(this.arcs.length > 0) {
        let maxArcValue = Math.max(...this.arcs.map(e => Math.abs(e.sourceEmission)))
        let maxArcWidth = 10

        let arcRatio = maxArcWidth / maxArcValue
          this.deck = new Deck({
            initialViewState: INITIAL_VIEW_STATE,
            controller: true,
            canvas: 'map-canvas',
            getTooltip: ({object}) => {
              return object && `${object.products} - ${object.origin}`
            },

            layers: [
              new GeoJsonLayer({
                id: 'base-map',
                data: COUNTRIES,
                // Styles
                stroked: true,
                filled: true,
                lineWidthMinPixels: 1,
                opacity: 0.4,
                getLineWidth: 1,
                getLineColor: [60, 60, 60],
                getFillColor: [0, 0, 0, 0]
              }),
              /*new GeoJsonLayer({
                id: 'airports',
                data: AIR_PORTS,
                // Styles
                filled: true,
                pointRadiusMinPixels: 2,
                pointRadiusScale: 2000,
                getRadius: f => 11 - f.properties.scalerank,
                getFillColor: [200, 0, 80, 180],
                // Interactive props
                pickable: true,
                autoHighlight: true,
                onClick: info =>
                  // eslint-disable-next-line
                  info.object && alert(`${info.object.properties.name} (${info.object.properties.abbrev})`)
              }),*/
              new ArcLayer({
                id: 'arcs',
                data: this.arcs,
                //dataTransform: d => d.features.filter(f => f.properties.scalerank < 4),
                // Styles
                pickable: true,
                highlightColor: d => d.object.sourceEmission > 0 ? redColorHover : greenColorHover,
                autoHighlight: true,
                onHover: info => {
                  //setTooltip(info.object, info.x, info.y)
                },
                getSourcePosition: d => TARGET_COORDS, // Valldaura Labs
                getTargetPosition: d => d.coords,
                getSourceColor: d => d.sourceEmission > 0 ? redColor : greenColor,
                getTargetColor: d => d.destinationEmission > 0 ? redColor : greenColor,
                getWidth: d => Math.max(Math.abs(d.sourceEmission * arcRatio), 2)
              })
            ]
        });
      }

    }
  },
  watch: {
    chartData () {
      this.drawMap()
    }
  }
}
</script>

<style lang="stylus" scoped>
.map-container
  position: relative
  height 80vh
  width 100%
</style>